import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';
import { SERVER_API_URL } from 'app/config/constants';

import { IBook, defaultValue } from 'app/shared/model/book.model';

export const ACTION_TYPES = {
  FETCH_BETTING_BOOK_AUTH_TOKEN: 'bettingBookAuthToken/FETCH_BETTING_BOOK_AUTH_TOKEN',
  RESET: 'bettingBookAuthToken/RESET'
};

const initialState = {
  loading: false,
  errorMessage: null,
  entity: defaultValue,
  updating: false,
  updateSuccess: false
};

export type BettingBookAuthTokenState = Readonly<typeof initialState>;

// Reducer

export default (state: BettingBookAuthTokenState = initialState, action): BettingBookAuthTokenState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_BETTING_BOOK_AUTH_TOKEN):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case FAILURE(ACTION_TYPES.FETCH_BETTING_BOOK_AUTH_TOKEN):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_BETTING_BOOK_AUTH_TOKEN):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = SERVER_API_URL + '/api/bettingbookauthtoken';

// Actions

export const getEntity = email => {
  const requestUrl = `${apiUrl}/${email}`;
  return {
    type: ACTION_TYPES.FETCH_BETTING_BOOK_AUTH_TOKEN,
    payload: axios.get(requestUrl)
  };
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
